export default {
    LandingPage: '/',
    Summary: '/summary',
    Details: '/details',
    ReDelivery: '/redelivery',
    UpdateDelivery: '/updatedelivery',
    ConfirmReDelivery: '/confirmredelivery',
    ConfirmUpdateDelivery: '/confirmupdatedelivery',
};
